
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g3S4jUu9rm5RNxuzyX2xnBwHZo6FiDV3LxmBxN6GQQ3wMeta } from "/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index6Z3U_45gkU_45hgW8Vr_cOmc9WLxO2OE31IgaF42R1__45eH8Meta } from "/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchcv_45sNjcDedxDbRh8xnGMoIOLVdjgqiTQbqPxt9iMR84Meta } from "/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexD8DVU9dFFgfkXT1SYY_e5b4pxi8yMAYwBz7l4U24AIIMeta } from "/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93JZixEDO_Sb4ZIojJrq_45RZ8E4vxKqLV9Efeus0XAcVMEMeta } from "/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexZcgTGu3We6XDNVz2bGFv7PaUpY6tMv0PI0_gKlm5p9UMeta } from "/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93MfaSoszZQfFmVqeuWF9D_0lo383KzdaQAb53MmAMfRIMeta } from "/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexmnCm7GkXUAe_45P_45xe0S6m86EqzBIyvL3HsmkR5rS55ykMeta } from "/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93qf5QIuRfOakymYNwlHf8ikUDiE0dEZ95_2KqXimqQ9AMeta } from "/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexvozcZt8pe303As_uxjSK0UZcWjXdeUX2rIDxvfqbTs4Meta } from "/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexYa4bFMtxu9LAqYQqGcogL8ABY7KySnR__45JvHlw0l3FQMeta } from "/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexZcgTGu3We6XDNVz2bGFv7PaUpY6tMv0PI0_gKlm5p9UMeta || {},
    component: () => import("/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexmnCm7GkXUAe_45P_45xe0S6m86EqzBIyvL3HsmkR5rS55ykMeta || {},
    component: () => import("/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexvozcZt8pe303As_uxjSK0UZcWjXdeUX2rIDxvfqbTs4Meta || {},
    component: () => import("/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexYa4bFMtxu9LAqYQqGcogL8ABY7KySnR__45JvHlw0l3FQMeta || {},
    component: () => import("/codebuild/output/src3264041218/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]